export interface GetCommitteeMembersInput {
  salesforceId: string;
  projectIds?: string[];
  committeesCategoriesIds?: string[];
  first?: number;
  offset?: number;
}
